import { httpTokenCommon } from "../helper/http-common";

class DashboardServices {
  getDashboardData() {
    return httpTokenCommon.get("customers/dashboard");
  }

  getBalanceSummary() {
    return httpTokenCommon.get("customers/balance-summary");
  }

  getWalletBalance() {
    return httpTokenCommon.get("customerswallets/getbalance");
  }
}

const dashboardServices = new DashboardServices();
export default dashboardServices;
